"use strict";

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@emotion/css", "react", "@emotion/core", "recompose/onlyUpdateForKeys", "./helpers"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@emotion/css"), require("react"), require("@emotion/core"), require("recompose/onlyUpdateForKeys"), require("./helpers"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.css, global.react, global.core, global.onlyUpdateForKeys, global.helpers);
    global.undefined = mod.exports;
  }
})(void 0, function (exports, _css2, _react, _core, _onlyUpdateForKeys, _helpers) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _css3 = _interopRequireDefault(_css2);

  var _react2 = _interopRequireDefault(_react);

  var _onlyUpdateForKeys2 = _interopRequireDefault(_onlyUpdateForKeys);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _templateObject2() {
    var data = _taggedTemplateLiteral(["\n  0%, 100% {transform: scale(0)} \n  50% {transform: scale(1.0)}\n"]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    var data = _taggedTemplateLiteral(["\n  100% {transform: rotate(360deg)}\n"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
      raw = strings.slice(0);
    }

    return Object.freeze(Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw)
      }
    }));
  }

  var rotate = (0, _core.keyframes)(_templateObject());
  var bounce = (0, _core.keyframes)(_templateObject2());

  var Loader = function (_React$Component) {
    _inherits(Loader, _React$Component);

    function Loader() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Loader);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Loader)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "style", function (i) {
        var _this$props = _this.props,
            size = _this$props.size,
            sizeUnit = _this$props.sizeUnit,
            color = _this$props.color;
        return (0, _core.css)("position:absolute;top:", i % 2 ? "0" : "auto", ";bottom:", i % 2 ? "auto" : "0", ";height:", "".concat(size / 2).concat(sizeUnit), ";width:", "".concat(size / 2).concat(sizeUnit), ";background-color:", color, ";border-radius:100%;animation-fill-mode:forwards;animation:", bounce, " 2s ", i === 2 ? "-1s" : "0s", " infinite linear;label:style;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9Eb3RMb2FkZXIuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW1CYyIsImZpbGUiOiJzcmMvRG90TG9hZGVyLmpzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IHsga2V5ZnJhbWVzLCBjc3MsIGpzeCB9IGZyb20gXCJAZW1vdGlvbi9jb3JlXCI7XG5pbXBvcnQgb25seVVwZGF0ZUZvcktleXMgZnJvbSBcInJlY29tcG9zZS9vbmx5VXBkYXRlRm9yS2V5c1wiO1xuaW1wb3J0IHsgc2l6ZVByb3BzLCBzaXplRGVmYXVsdHMsIHNpemVLZXlzIH0gZnJvbSBcIi4vaGVscGVyc1wiO1xuXG5jb25zdCByb3RhdGUgPSBrZXlmcmFtZXNgXG4gIDEwMCUge3RyYW5zZm9ybTogcm90YXRlKDM2MGRlZyl9XG5gO1xuXG5jb25zdCBib3VuY2UgPSBrZXlmcmFtZXNgXG4gIDAlLCAxMDAlIHt0cmFuc2Zvcm06IHNjYWxlKDApfSBcbiAgNTAlIHt0cmFuc2Zvcm06IHNjYWxlKDEuMCl9XG5gO1xuXG5jbGFzcyBMb2FkZXIgZXh0ZW5kcyBSZWFjdC5Db21wb25lbnQge1xuICBzdHlsZSA9IChpKSA9PiB7XG4gICAgY29uc3QgeyBzaXplLCBzaXplVW5pdCwgY29sb3IgfSA9IHRoaXMucHJvcHM7XG5cbiAgICByZXR1cm4gY3NzYFxuICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgdG9wOiAke2kgJSAyID8gXCIwXCIgOiBcImF1dG9cIn07XG4gICAgICBib3R0b206ICR7aSAlIDIgPyBcImF1dG9cIiA6IFwiMFwifTtcbiAgICAgIGhlaWdodDogJHtgJHtzaXplIC8gMn0ke3NpemVVbml0fWB9O1xuICAgICAgd2lkdGg6ICR7YCR7c2l6ZSAvIDJ9JHtzaXplVW5pdH1gfTtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICR7Y29sb3J9O1xuICAgICAgYm9yZGVyLXJhZGl1czogMTAwJTtcbiAgICAgIGFuaW1hdGlvbi1maWxsLW1vZGU6IGZvcndhcmRzO1xuICAgICAgYW5pbWF0aW9uOiAke2JvdW5jZX0gMnMgJHtpID09PSAyID8gXCItMXNcIiA6IFwiMHNcIn0gaW5maW5pdGUgbGluZWFyO1xuICAgIGA7XG4gIH07XG5cbiAgd3JhcHBlciA9ICgpID0+IHtcbiAgICBjb25zdCB7IHNpemUsIHNpemVVbml0IH0gPSB0aGlzLnByb3BzO1xuXG4gICAgcmV0dXJuIGNzc2BcbiAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgIHdpZHRoOiAke2Ake3NpemV9JHtzaXplVW5pdH1gfTtcbiAgICAgIGhlaWdodDogJHtgJHtzaXplfSR7c2l6ZVVuaXR9YH07XG4gICAgICBhbmltYXRpb24tZmlsbC1tb2RlOiBmb3J3YXJkcztcbiAgICAgIGFuaW1hdGlvbjogJHtyb3RhdGV9IDJzIDBzIGluZmluaXRlIGxpbmVhcjtcbiAgICBgO1xuICB9O1xuXG4gIHJlbmRlcigpIHtcbiAgICBjb25zdCB7IGxvYWRpbmcsIGNzcyB9ID0gdGhpcy5wcm9wcztcblxuICAgIHJldHVybiBsb2FkaW5nID8gKFxuICAgICAgPGRpdiBjc3M9e1t0aGlzLndyYXBwZXIoKSwgY3NzXX0+XG4gICAgICAgIDxkaXYgY3NzPXt0aGlzLnN0eWxlKDEpfSAvPlxuICAgICAgICA8ZGl2IGNzcz17dGhpcy5zdHlsZSgyKX0gLz5cbiAgICAgIDwvZGl2PlxuICAgICkgOiBudWxsO1xuICB9XG59XG5cbkxvYWRlci5wcm9wVHlwZXMgPSBzaXplUHJvcHM7XG5cbkxvYWRlci5kZWZhdWx0UHJvcHMgPSBzaXplRGVmYXVsdHMoNjApO1xuXG5jb25zdCBDb21wb25lbnQgPSBvbmx5VXBkYXRlRm9yS2V5cyhzaXplS2V5cykoTG9hZGVyKTtcbkNvbXBvbmVudC5kZWZhdWx0UHJvcHMgPSBMb2FkZXIuZGVmYXVsdFByb3BzO1xuZXhwb3J0IGRlZmF1bHQgQ29tcG9uZW50O1xuIl19 */"));
      });

      _defineProperty(_assertThisInitialized(_this), "wrapper", function () {
        var _this$props2 = _this.props,
            size = _this$props2.size,
            sizeUnit = _this$props2.sizeUnit;
        return (0, _core.css)("position:relative;width:", "".concat(size).concat(sizeUnit), ";height:", "".concat(size).concat(sizeUnit), ";animation-fill-mode:forwards;animation:", rotate, " 2s 0s infinite linear;label:wrapper;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
      });

      return _this;
    }

    _createClass(Loader, [{
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
            loading = _this$props3.loading,
            css = _this$props3.css;
        return loading ? (0, _core.jsx)("div", {
          css: (0, _css3["default"])([this.wrapper(), css], "label:Loader;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"))
        }, (0, _core.jsx)("div", {
          css: this.style(1)
        }), (0, _core.jsx)("div", {
          css: this.style(2)
        })) : null;
      }
    }]);

    return Loader;
  }(_react2["default"].Component);

  Loader.propTypes = _helpers.sizeProps;
  Loader.defaultProps = (0, _helpers.sizeDefaults)(60);
  var Component = (0, _onlyUpdateForKeys2["default"])(_helpers.sizeKeys)(Loader);
  Component.defaultProps = Loader.defaultProps;
  exports["default"] = Component;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-spinners/DotLoader.js
// module id = 994
// module chunks = 0